import * as firebase from 'firebase/app'
import * as React from 'react'
import { Link, NavLink, Route } from 'react-router-dom'

import ClientEditor from 'components/ClientEditor'
import Icon from 'components/Icon'
import AuthContext, { IAuthContext } from 'context/AuthContext'
import { IClient } from 'interfaces/IClient'

class Clients extends React.Component<{
  company: IAuthContext['company']
  clients: IAuthContext['clients']
}> {
  public client = (id: string): IClient => {
    return this.props.clients[id] || {}
  }

  public delete(id: string) {
    const { currentUser } = firebase.auth()

    if (!currentUser) {
      throw new Error()
    }

    if (confirm('Are you sure?')) {
      firebase
        .database()
        .ref(`/clients/${currentUser.uid}/${this.props.company}/${id}`)
        .set(null)
    }
  }

  public render() {
    const { props, client } = this

    return (
      <div>
        <ul id="nav">
          <li>
            <NavLink activeClassName="active" exact to="/clients">
              <Icon icon="view" />
              Visa Kunder
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/clients/create">
              <Icon icon="add" />
              Lägg till kund
            </NavLink>
          </li>
        </ul>
        <Route
          exact
          path="/clients"
          render={() => (
            <table>
              <thead>
                <tr>
                  <th>Företag/Namn</th>
                  <th>Adress</th>
                  <th colSpan={4} />
                </tr>
              </thead>
              <tbody>
                {Object.keys(props.clients).map(id => (
                  <tr key={id}>
                    <td>
                      <strong>{client(id).name}</strong>
                      <br />
                      <small>{client(id).reference}</small>
                    </td>
                    <td>
                      {client(id).adress}
                      <br />
                      {client(id).zip} {client(id).city}
                    </td>
                    <td className="border">
                      <Link to={`/invoices/create/?clientKey=${id}`}>
                        Ny faktura
                      </Link>
                    </td>
                    <td className="border">
                      <Link to={`/invoices/?clientKey=${id}`}>
                        Visa fakturor
                      </Link>
                    </td>
                    <td className="border">
                      <Link to={`/clients/edit/${id}`}>
                        <Icon icon="edit" />
                      </Link>
                    </td>
                    <td className="border">
                      <a onClick={() => this.delete(id)}>
                        <Icon icon="remove" />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        />
        <Route
          exact
          path="/clients/create"
          render={p =>
            props.company && <ClientEditor {...p} company={props.company} />
          }
        />
        <Route
          exact
          path="/clients/edit/:id"
          render={p =>
            props.company && <ClientEditor {...p} company={props.company} />
          }
        />
      </div>
    )
  }
}

export default (props: {}) => (
  <AuthContext.Consumer>
    {({ clients, company }) => (
      <Clients {...props} company={company} clients={clients} />
    )}
  </AuthContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/components/Clients/Clients.tsx